import React from 'react';
import { Section } from './Section';
import { Download, Zap, ShieldCheck } from 'lucide-react';
export const ComoFunciona = () => {
  const steps = [{
    icon: Download,
    title: 'Descargás',
    desc: 'Recibís el PDF directamente en tu celular o compu.'
  }, {
    icon: Zap,
    title: 'Activás',
    desc: 'Elegís uno de los 3 protocolos de blindaje antes de entrar a tu próxima reunión.'
  }, {
    icon: ShieldCheck,
    title: 'Recuperás',
    desc: 'Cortás los hilos al salir y sentís cómo tu energía vuelve a ser tuya al llegar a casa.'
  }];
  return <Section className="bg-navy-900/50 border-y border-gold/10" data-id="element-25">
      <div className="text-center mb-16" data-id="element-26">
        <h2 className="text-3xl md:text-5xl font-serif mb-4" data-id="element-27">Cómo funciona</h2>
        <div className="w-16 h-px bg-gold/50 mx-auto" data-id="element-28" />
      </div>

      <div className="max-w-4xl mx-auto relative" data-id="element-29">
        {/* Connecting line for desktop */}
        <div className="hidden md:block absolute top-12 left-20 right-20 h-px bg-gold/20" data-id="element-30" />

        <div className="grid md:grid-cols-3 gap-10 relative z-10" data-id="element-31">
          {steps.map((step, i) => <div key={i} className="flex flex-col items-center text-center group" data-id="element-32">
              <div className="w-24 h-24 rounded-full border border-gold/30 bg-navy-800 flex items-center justify-center mb-6 relative group-hover:border-gold transition-colors shadow-[0_0_15px_rgba(201,169,97,0.1)]" data-id="element-33">
                <div className="absolute -top-3 -right-3 w-8 h-8 rounded-full bg-gold text-navy-900 flex items-center justify-center font-serif font-bold" data-id="element-34">
                  {i + 1}
                </div>
                <step.icon size={32} className="text-gold" strokeWidth={1.5} data-id="element-35" />
              </div>
              <h3 className="text-2xl font-serif text-offwhite mb-3" data-id="element-36">
                {step.title}
              </h3>
              <p className="text-gray-400 font-light" data-id="element-37">{step.desc}</p>
            </div>)}
        </div>
      </div>
    </Section>;
};